import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showModal } from "../statusModal/statusModal";
import { fetchAppAdminsAPI, setUserAppAdminStatusAPI } from "./appAdminsAPI";

const initialState = {
  items: [],
  total: 0,
  fetchStatus: "idle",
  updateStatus: "idle",
  error: null,
};

export const fetchAppAdmins = createAsyncThunk(
  "appAdmins/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await fetchAppAdminsAPI(params);
      return response?.data || {};
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.errorKey || "errors.server.internalError",
      );
    }
  },
);

export const setUserAppAdminStatus = createAsyncThunk(
  "appAdmins/setStatus",
  async ({ userId, isAppAdmin }, { dispatch, rejectWithValue }) => {
    try {
      const response = await setUserAppAdminStatusAPI({ userId, isAppAdmin });
      dispatch(
        showModal({
          message: isAppAdmin
            ? "تمت إضافة المستخدم كأدمن داخل التطبيق"
            : "تمت إزالة المستخدم من أدمن التطبيق",
          status: "success",
        }),
      );
      return response?.data;
    } catch (error) {
      dispatch(
        showModal({
          message: "فشل تحديث حالة أدمن التطبيق",
          status: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.errorKey || "errors.server.internalError",
      );
    }
  },
);

const appAdminsSlice = createSlice({
  name: "appAdmins",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppAdmins.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchAppAdmins.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.items = Array.isArray(action.payload?.items)
          ? action.payload.items
          : [];
        state.total = Number(action.payload?.total || 0);
      })
      .addCase(fetchAppAdmins.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload || "errors.server.internalError";
      })
      .addCase(setUserAppAdminStatus.pending, (state) => {
        state.updateStatus = "loading";
        state.error = null;
      })
      .addCase(setUserAppAdminStatus.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        const updatedUser = action.payload;
        if (!updatedUser?._id) return;

        if (updatedUser?.isAppAdmin) {
          const exists = state.items.some(
            (item) => String(item?._id || "") === String(updatedUser._id),
          );
          if (!exists) {
            state.items = [updatedUser, ...state.items];
            state.total = Number(state.total || 0) + 1;
          } else {
            state.items = state.items.map((item) =>
              String(item?._id || "") === String(updatedUser._id)
                ? { ...item, ...updatedUser }
                : item,
            );
          }
          return;
        }

        const before = state.items.length;
        state.items = state.items.filter(
          (item) => String(item?._id || "") !== String(updatedUser._id),
        );
        state.total = Math.max(0, Number(state.total || 0) - (before - state.items.length));
      })
      .addCase(setUserAppAdminStatus.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.error = action.payload || "errors.server.internalError";
      });
  },
});

export default appAdminsSlice.reducer;
